export function NewTabIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M17.49,1.72H12.88a.79.79,0,0,0-.56.23.83.83,0,0,0-.23.56.79.79,0,0,0,.23.55.8.8,0,0,0,.56.24h2.71L7.17,11.71a.84.84,0,0,0-.22.56.8.8,0,0,0,.24.56.78.78,0,0,0,1.1,0L16.7,4.41V7.12a.8.8,0,0,0,.24.56.79.79,0,0,0,.55.23.84.84,0,0,0,.56-.24h0a.75.75,0,0,0,.23-.55V2.51a.79.79,0,0,0-.79-.79Z" />
      <path d="M14.5,10.58V16.7H3.3V5.5H9.42a.79.79,0,1,0,0-1.57H2.51a.79.79,0,0,0-.79.78V17.49a.79.79,0,0,0,.79.79H15.29a.76.76,0,0,0,.55-.23h0a.79.79,0,0,0,.23-.56V10.58a.79.79,0,1,0-1.57,0Z" />
    </svg>
  )
}
